/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Error,
  PatchMeBody,
  UpdateUserFinaSettingsBody,
  UpdateUserFursSettingsBody,
  UpdateUserPtSettingsBody,
  User,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Retrieve the authenticated user's profile information. Returns the user details associated with the provided Bearer token.
 * @summary Get current user
 */
export type getMeResponse200 = {
  data: User
  status: 200
}

export type getMeResponse401 = {
  data: Error
  status: 401
}

export type getMeResponse403 = {
  data: Error
  status: 403
}

export type getMeResponse404 = {
  data: Error
  status: 404
}

export type getMeResponse500 = {
  data: Error
  status: 500
}

export type getMeResponseSuccess = (getMeResponse200) & {
  headers: Headers;
};
export type getMeResponseError = (getMeResponse401 | getMeResponse403 | getMeResponse404 | getMeResponse500) & {
  headers: Headers;
};

export type getMeResponse = (getMeResponseSuccess | getMeResponseError)

export const getGetMeUrl = () => {


  

  return `/users/me`
}

export const getMe = async ( options?: RequestInit): Promise<getMeResponse> => {
  
  return customFetch<getMeResponse>(getGetMeUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Update the authenticated user's profile. Currently supports updating the display name and preferred UI language (locale).
 * @summary Update current user
 */
export type patchMeResponse200 = {
  data: User
  status: 200
}

export type patchMeResponse400 = {
  data: Error
  status: 400
}

export type patchMeResponse401 = {
  data: Error
  status: 401
}

export type patchMeResponse403 = {
  data: Error
  status: 403
}

export type patchMeResponse404 = {
  data: Error
  status: 404
}

export type patchMeResponse422 = {
  data: ValidationError
  status: 422
}

export type patchMeResponse500 = {
  data: Error
  status: 500
}

export type patchMeResponseSuccess = (patchMeResponse200) & {
  headers: Headers;
};
export type patchMeResponseError = (patchMeResponse400 | patchMeResponse401 | patchMeResponse403 | patchMeResponse404 | patchMeResponse422 | patchMeResponse500) & {
  headers: Headers;
};

export type patchMeResponse = (patchMeResponseSuccess | patchMeResponseError)

export const getPatchMeUrl = () => {


  

  return `/users/me`
}

export const patchMe = async (patchMeBody: PatchMeBody, options?: RequestInit): Promise<patchMeResponse> => {
  
  return customFetch<patchMeResponse>(getPatchMeUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchMeBody,)
  }
);}
  

/**
 * Update FURS operator settings (tax number, label) for the current user. Settings are stored per-entity using the x-entity-id header. These settings are used when the user creates invoices through the web interface.
 * @summary Update user FURS operator settings
 */
export type updateUserFursSettingsResponse200 = {
  data: User
  status: 200
}

export type updateUserFursSettingsResponse400 = {
  data: Error
  status: 400
}

export type updateUserFursSettingsResponse401 = {
  data: Error
  status: 401
}

export type updateUserFursSettingsResponse403 = {
  data: Error
  status: 403
}

export type updateUserFursSettingsResponse404 = {
  data: Error
  status: 404
}

export type updateUserFursSettingsResponse422 = {
  data: ValidationError
  status: 422
}

export type updateUserFursSettingsResponse500 = {
  data: Error
  status: 500
}

export type updateUserFursSettingsResponseSuccess = (updateUserFursSettingsResponse200) & {
  headers: Headers;
};
export type updateUserFursSettingsResponseError = (updateUserFursSettingsResponse400 | updateUserFursSettingsResponse401 | updateUserFursSettingsResponse403 | updateUserFursSettingsResponse404 | updateUserFursSettingsResponse422 | updateUserFursSettingsResponse500) & {
  headers: Headers;
};

export type updateUserFursSettingsResponse = (updateUserFursSettingsResponseSuccess | updateUserFursSettingsResponseError)

export const getUpdateUserFursSettingsUrl = () => {


  

  return `/users/me/settings/furs`
}

export const updateUserFursSettings = async (updateUserFursSettingsBody: UpdateUserFursSettingsBody, options?: RequestInit): Promise<updateUserFursSettingsResponse> => {
  
  return customFetch<updateUserFursSettingsResponse>(getUpdateUserFursSettingsUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateUserFursSettingsBody,)
  }
);}
  

/**
 * Update FINA operator settings (OIB, label) for the current user. Settings are stored per-entity using the x-entity-id header. These settings are used when the user creates invoices through the web interface.
 * @summary Update user FINA operator settings
 */
export type updateUserFinaSettingsResponse200 = {
  data: User
  status: 200
}

export type updateUserFinaSettingsResponse400 = {
  data: Error
  status: 400
}

export type updateUserFinaSettingsResponse401 = {
  data: Error
  status: 401
}

export type updateUserFinaSettingsResponse403 = {
  data: Error
  status: 403
}

export type updateUserFinaSettingsResponse404 = {
  data: Error
  status: 404
}

export type updateUserFinaSettingsResponse422 = {
  data: ValidationError
  status: 422
}

export type updateUserFinaSettingsResponse500 = {
  data: Error
  status: 500
}

export type updateUserFinaSettingsResponseSuccess = (updateUserFinaSettingsResponse200) & {
  headers: Headers;
};
export type updateUserFinaSettingsResponseError = (updateUserFinaSettingsResponse400 | updateUserFinaSettingsResponse401 | updateUserFinaSettingsResponse403 | updateUserFinaSettingsResponse404 | updateUserFinaSettingsResponse422 | updateUserFinaSettingsResponse500) & {
  headers: Headers;
};

export type updateUserFinaSettingsResponse = (updateUserFinaSettingsResponseSuccess | updateUserFinaSettingsResponseError)

export const getUpdateUserFinaSettingsUrl = () => {


  

  return `/users/me/settings/fina`
}

export const updateUserFinaSettings = async (updateUserFinaSettingsBody: UpdateUserFinaSettingsBody, options?: RequestInit): Promise<updateUserFinaSettingsResponse> => {
  
  return customFetch<updateUserFinaSettingsResponse>(getUpdateUserFinaSettingsUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateUserFinaSettingsBody,)
  }
);}
  

/**
 * Update PT operator snapshot settings for the current user. Settings are stored per-entity using the x-entity-id header and used to auto-fill PT operator fields when the user creates PT documents.
 * @summary Update user Portugal operator settings
 */
export type updateUserPtSettingsResponse200 = {
  data: User
  status: 200
}

export type updateUserPtSettingsResponse400 = {
  data: Error
  status: 400
}

export type updateUserPtSettingsResponse401 = {
  data: Error
  status: 401
}

export type updateUserPtSettingsResponse403 = {
  data: Error
  status: 403
}

export type updateUserPtSettingsResponse404 = {
  data: Error
  status: 404
}

export type updateUserPtSettingsResponse422 = {
  data: ValidationError
  status: 422
}

export type updateUserPtSettingsResponse500 = {
  data: Error
  status: 500
}

export type updateUserPtSettingsResponseSuccess = (updateUserPtSettingsResponse200) & {
  headers: Headers;
};
export type updateUserPtSettingsResponseError = (updateUserPtSettingsResponse400 | updateUserPtSettingsResponse401 | updateUserPtSettingsResponse403 | updateUserPtSettingsResponse404 | updateUserPtSettingsResponse422 | updateUserPtSettingsResponse500) & {
  headers: Headers;
};

export type updateUserPtSettingsResponse = (updateUserPtSettingsResponseSuccess | updateUserPtSettingsResponseError)

export const getUpdateUserPtSettingsUrl = () => {


  

  return `/users/me/settings/pt`
}

export const updateUserPtSettings = async (updateUserPtSettingsBody: UpdateUserPtSettingsBody, options?: RequestInit): Promise<updateUserPtSettingsResponse> => {
  
  return customFetch<updateUserPtSettingsResponse>(getUpdateUserPtSettingsUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateUserPtSettingsBody,)
  }
);}
  

